import React from 'react';

/** Rendu markdown compact, lisible pour des clients (pas de titres géants). */
export const assistantMarkdownComponents = {
  h1: ({ children }) => <p className="assistant-md__heading">{children}</p>,
  h2: ({ children }) => <p className="assistant-md__heading">{children}</p>,
  h3: ({ children }) => <p className="assistant-md__subheading">{children}</p>,
  h4: ({ children }) => <p className="assistant-md__subheading">{children}</p>,
  h5: ({ children }) => <p className="assistant-md__label">{children}</p>,
  h6: ({ children }) => <p className="assistant-md__label">{children}</p>,
  p: ({ children }) => <p className="assistant-md__paragraph">{children}</p>,
  li: ({ children }) => <li className="assistant-md__list-item">{children}</li>,
  strong: ({ children }) => <strong className="assistant-md__strong">{children}</strong>,
  table: ({ children }) => (
    <div className="assistant-md__table-wrap">
      <table className="assistant-md__table">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="assistant-md__thead">{children}</thead>,
  tbody: ({ children }) => <tbody>{children}</tbody>,
  tr: ({ children }) => <tr>{children}</tr>,
  th: ({ children }) => <th className="assistant-md__th">{children}</th>,
  td: ({ children }) => <td className="assistant-md__td">{children}</td>,
};
